import { render, staticRenderFns } from "./ShippingCostsComponent.vue?vue&type=template&id=3e9c8d86&"
import script from "./ShippingCostsComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingCostsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports